<template>
    <div class="social" :class="{ social_collapsed: mobileCollapsed }">
        <div
            class="social__icon social-links-item contains_background_image"
            :data-voicetext="network.text"
            :class="{
                [`social__icon_${network.name}`]: true,
                [`social__icon_${network.name}_gray`]: (!isFilled || error) && collapsed,
            }"
            title="Привязать профиль"
            @click="clickHandler"
        ></div>
        <div class="social__input-wrap" :class="{ 'social__input-wrap_error': error }">
            <div v-if="url && !error" class="social__value">
                <a class="social__link" :href="url" target="_blank">{{ url }}</a>
            </div>
            <input
                v-else
                ref="input"
                class="social__input"
                v-model="currentValue"
                @focusout="apply"
                @keyup.enter="apply"
                placeholder="Добавьте адрес профиля"
            />
            <div class="social__action-icons-wrapper">
                <font-awesome-icon
                    class="social__action-icon social__handlers"
                    icon="times"
                    @click="deleteItem"
                ></font-awesome-icon>
            </div>
        </div>
        <div v-if="!collapsed && !isMobile" class="social__error">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'socialNetworkInputv2',
    data: () => ({
        socialNetworks: {
            vk: {
                name: 'vk',
                text: '«Вконтакте»',
                pattern: /^(https?:\/\/)?((www\.)|(m\.))?vk\.(ru|com)\/[\S]{1,}$/,
            },
            maxMessenger: {
                name: 'maxMessenger',
                text: '«Макс»',
                pattern: /^(https?:\/\/)?(www\.)?max\.ru\/(u\/)?[a-zA-Z0-9_-]{1,200}\/?$/,
            },
            ok: {
                name: 'ok',
                text: '«Одноклассники»',
                pattern: /^(https?:\/\/)?((www\.)|(m\.))?ok\.ru\/[\S]{1,}$/,
            },
            yt: {
                name: 'yt',
                text: '«Ютьюб»',
                pattern: /^(https?:\/\/)?((www\.)|(m\.))?youtube.com\/(channel\/|@)[\S]+$/,
            },
            tiktok: {
                name: 'tiktok',
                text: '«Тик-Ток»',
                pattern: /^(https?:\/\/)?((www\.)|(m\.)|(vm\.))?tiktok.com\/[\S]{1,}$/,
            },
            zen: {
                name: 'zen',
                text: '«Дзен»',
                pattern: /^(https?:\/\/)?((www\.)|(m\.))?((zen.yandex)|(dzen)){1}.((com)|(ru))\/[\S]{1,}$/,
            },
            telegram: {
                name: 'telegram',
                text: '«Телеграм»',
                pattern: /^(https?:\/\/)?t.me\/[\S]{5,}$/,
            },
            rutube: {
                name: 'rutube',
                text: '«Рутьюб»',
                pattern: /^(https?:\/\/)?rutube\.ru\/(channel\/\S+|u\/[a-zA-Z0-9_-]+\/?)$/,
            },
            yappy: {
                name: 'yappy',
                text: '«Яппи»',
                pattern: /^(https?:\/\/)?yappy\.media\/n\/[\S]{1,}$/,
            },
            tenchat: {
                name: 'tenchat',
                text: '«Тенчат»',
                pattern: /^(https?:\/\/)?(www\.)?tenchat\.ru\/[a-zA-Z0-9_-]+\/?$/,
            },
        },
        currentValue: '',
        collapsed: true,
        error: '',
    }),
    props: {
        socialNetwork: String,
        url: {
            type: String,
            default: '',
        },
        isActive: Boolean,
        isMobile: Boolean,
        collapsible: {
            type: Boolean,
            default: true,
        },
        snError: {
            type: String,
            default: '',
        },
    },
    model: {
        prop: 'url',
        event: 'change',
    },
    computed: {
        isFilled() {
            return this.currentValue !== '' && this.currentValue != null;
        },
        mobileCollapsed() {
            return this.isMobile || this.collapsed;
        },
        network() {
            return this.socialNetworks[this.socialNetwork];
        },
    },
    methods: {
        validate() {
            return this.currentValue === '' || this.currentValue.match(this.network.pattern);
        },
        apply() {
            if (this.validate()) {
                if (this.currentValue !== '') {
                    if (!this.currentValue.includes('https://') && !this.currentValue.includes('http://')) {
                        this.currentValue = 'https://' + this.currentValue;
                    }
                    if (this.currentValue.substring(0, 7) === 'http://') {
                        this.currentValue = 'https://' + this.currentValue.substring(7);
                    }
                }
                this.error = '';
            } else {
                this.error = 'Некорректная ссылка на социальную сеть';
            }
            this.$emit('change', this.currentValue);
            this.$emit('error', this.error);
        },
        deleteItem() {
            this.currentValue = null;
            this.error = '';
            this.$emit('change', null);
            this.$emit('error', this.error);
        },
        clickHandler() {
            this.$emit('click', {
                collapsed: this.collapsed,
                error: this.error,
            });
        },
    },
    watch: {
        isActive() {
            this.collapsed = !this.isActive;
        },
        url() {
            if (!this.url || this.url === '') {
                this.currentValue = '';
            } else {
                this.currentValue = this.url;
            }
        },
    },
    created() {
        this.collapsed = !this.isActive;
        this.error = this.snError;
        this.currentValue = this.url;
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';
@import '~@/styles/variables';

/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

.social {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    transition: all 0.3s linear;
    margin: 0 mrem(10) mrem(20) mrem(10);

    @include on-desktop {
        display: inline-flex;
        width: rem(270);
        max-width: 100%;
        margin-right: rem(20);
        margin-left: 0;
        margin-bottom: rem(16);
    }

    &_collapsed {
        width: mrem(40);
        height: mrem(40);
        margin-left: mrem(10);
        margin-right: mrem(10);
        display: inline-flex;

        @include on-desktop {
            width: rem(40);
            height: rem(40);
            margin-right: rem(20);
            margin-left: 0;
        }
        .social {
            &__input-wrap {
                &_error {
                    border: rem(1) solid #d2d5d9;
                }
            }
        }
    }

    &__icon {
        position: absolute;
        left: 0;
        width: mrem(40);
        height: mrem(40);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #fff;
        border-radius: 50%;
        z-index: 1;
        cursor: pointer;
        transition: all 0.3s linear;

        &_vk {
            background-image: url('~@/assets/images/social/color/vk.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/vk.svg');
            }
        }

        &_maxMessenger {
            background-image: url('~@/assets/images/social/color/max.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/max.svg');
            }
        }

        &_ok {
            background-image: url('~@/assets/images/social/color/ok.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/ok.svg');
            }
        }

        &_ig {
            background-image: url('~@/assets/images/social/color/ig.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/ig.svg');
            }
        }

        &_fb {
            background-image: url('~@/assets/images/social/color/fb.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/fb.svg');
            }
        }

        &_yt {
            background-image: url('~@/assets/images/social/color/yt.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/yt.svg');
            }
        }

        &_tiktok {
            background-image: url('~@/assets/images/social/color/tiktok.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/tiktok.svg');
            }
        }

        &_zen {
            background-image: url('~@/assets/images/social/color/dzen.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/dzen.svg');
            }
        }

        &_telegram {
            background-image: url('~@/assets/images/social/color/telegram.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/telegram.svg');
            }
        }

        &_rutube {
            background-image: url('~@/assets/images/social/color/rutube.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/rutube.svg');
            }
        }

        &_yappy {
            background-image: url('~@/assets/images/social/color/yappy.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/yappy.svg');
            }
        }

        &_tenchat {
            background-image: url('~@/assets/images/social/color/tenchat.svg');
            &_gray {
                background-image: url('~@/assets/images/social/gray/tenchat.svg');
            }
        }

        @include on-desktop {
            width: rem(40);
            height: rem(40);
            flex: none;
        }
    }

    &__action-icon {
        width: mrem(12);
        height: mrem(12);
        margin-left: mrem(15);
        color: #98a0a9;

        @include on-desktop {
            width: rem(12);
            height: rem(12);
            margin-left: rem(6);
        }
    }

    &__action-icons-wrapper {
        position: absolute;
        right: mrem(15);
        top: 0;
        cursor: pointer;
        height: 100%;
        display: flex;
        align-items: center;

        @include on-desktop {
            right: rem(12);
        }
    }

    &__input-wrap {
        flex: 1;
        margin-left: mrem(20);
        padding: 0;
        width: 100%;
        height: mrem(40);
        overflow: hidden;
        background: #f7f7f8;
        border-radius: 0 120px 120px 0;
        border: mrem(1) solid #d2d5d9;
        position: relative;
        @include on-desktop {
            margin-left: rem(20);
            padding: 0;
            height: rem(40);
            border: rem(1) solid #d2d5d9;
        }
        &_error {
            border: 1px solid #d1004a;
        }
    }

    &__value {
        display: flex;
        align-items: center;
        a {
            color: #4663ab;
            text-decoration: underline;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    &__value,
    &__input {
        width: 100%;
        height: 100%;
        padding: 0 mrem(25);
        font-size: mrem(14);
        background: none;
        border: 0;
        &::placeholder {
            color: #98a0a9;
        }

        @include on-desktop {
            padding: 0 rem(25);
            flex: 1 1 auto;
            font-weight: 400;
            font-size: rem(14);
        }
    }

    .social__error {
        position: absolute;
        top: 100%;
        left: mrem(10);
        font-size: mrem(12);
        color: #d1004a;

        @include on-desktop {
            font-size: rem(12);
            left: rem(10);
        }
    }
}
</style>
